import { Construction } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { EmptyState } from '../../components/empty-state'
import { PageHeader } from '../../components/page-header'

/**
 * Stand-in for a module whose feature work lands in a later phase.
 *
 * It exists so navigation, permissions and deep links are real from day one —
 * a nav entry that leads to a blank screen teaches a customer to distrust the
 * whole menu.
 */
export function ModulePlaceholderPage({ navKey }: { navKey: string }) {
  const { t } = useTranslation()

  return (
    <div className="mx-auto max-w-7xl">
      <PageHeader title={t(`nav:items.${navKey}`)} description={t(`nav:hints.${navKey}`)} />
      <EmptyState
        icon={Construction}
        title={t('common:placeholder.title')}
        description={t('common:placeholder.description')}
      />
    </div>
  )
}
